import { Event } from '../Event'
import { ViewerContext } from '../../constants'

export interface PathQuestionSubmittedEventProperties {
  attribute_name: string
  parent_category_slug: string
  value: number | string | string[] | Date | null | undefined
}

export class PathQuestionSubmittedEvent extends Event<PathQuestionSubmittedEventProperties> {
  static displayName = 'Path Question Submitted'

  static allowedViewerContexts = [ViewerContext.Consumer]
}
